const Loader = () => {
    const colors = [
        "#003566",
        "#0077b6",
        "#00b4d8",
        "#48cae4",
        "#90e0ef",
        "#caf0f8",
      ];
  
    const styles = {
      wrapper: {
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      },
      text: {
        color: "#1ba6c9",
        letterSpacing: "4px",
        marginBottom: "10px",
        fontWeight: "600",
      },
      dots: {
        display: "flex",
      },
      dot: (delay, color) => ({
        width: "20px",
        height: "20px",
        margin: "10px",
        backgroundColor: color,
        borderRadius: "50%",
        animation: `bounce 1.4s infinite ease-in-out`,
        animationDelay: delay,
      }),
    };
  
    const delays = ["-0.32s", "-0.16s", "0s", "0.16s", "0.32s", "0.48s"];
  
    return (
      <div style={styles.wrapper}>
        <style>
          {`
            @keyframes bounce {
              0%, 80%, 100% {
                transform: scale(0.5);
                opacity: 0.5;
              }
              40% {
                transform: scale(1);
                opacity: 1;
              }
            }
          `}
        </style>
  
        <h1 style={styles.text}>LOADING ERP</h1>
  
        <div style={styles.dots}>
          {colors.map((color, i) => (
            <span key={i} style={styles.dot(delays[i], color)} />
          ))}
        </div>
      </div>
    );
  };
  
  export default Loader;